@if (commissionerData; as commissioner) {
    <div class="accordion-container">
        <cll-card-divider />

        @if (completeWeekdays; as weekDays) {
            @if (weekDays.length > 0) {
                @for (weekDay of weekDays; track weekDay.id) {
                    <div class="working-hour-double-row">
                        <div class="working-hour-field">
                            <span class="working-hour-weekday">{{ weekDay.weekday }}</span>
                        </div>
                        <div class="working-hour-field">
                            <span class="working-hour-time">
                                @if (weekDay.open && weekDay.start_time && weekDay.end_time) {
                                    {{ weekDay.start_time + ' - ' + weekDay.end_time }}
                                } @else {
                                    Closed
                                }
                            </span>
                        </div>
                    </div>
                }
            } @else {
                <p>No working hours</p>
                <button cll-tonal-button (click)="editWorkingHours()">
                    Add
                    <cll-icon cllButtonIcon type="outlined" [size]="20">arrow_forward</cll-icon>
                </button>
            }
        }

        <hr>

        @if (commissioner.special_hours.length > 0) {

            @for (specialHour of commissioner.special_hours; track specialHour.id) {

                <div class="working-hour-double-row">
                    <div class="working-hour-field">
                        <span class="working-hour-weekday">{{ specialHour.name }}</span>
                        <span class="working-hour-weekday">{{ specialHour.date | date: 'dd/MM/yyyy'}}</span>
                    </div>
                    <div class="working-hour-field">
                        @if (specialHour.open) {
                            <span class="working-hour-time">
                                {{ specialHour.start_time + ' - ' + specialHour.end_time }}
                            </span>
                        }
                        @if(!specialHour.open) {
                            <span class="working-hour-time">Closed</span>
                        }
                    </div>
                </div>
            }
        }

        @if (commissioner.status){
            <cll-card-footer>
                <button cll-tonal-button (click)="editWorkingHours()">
                    <cll-icon cllButtonIcon type="outlined" [size]="20">edit</cll-icon>
                    Edit
                </button>
            </cll-card-footer>
        }

    </div>
}
